import { MILEAGE_UNIT } from '../types';
import getConfig from 'next/config';

const {
  publicRuntimeConfig: { MIGRATED_PUBLISH_FILTER_SECTIONS },
} = getConfig();

export const years: string[] = [
  '2001',
  '2002',
  '2003',
  '2004',
  '2005',
  '2006',
  '2007',
  '2008',
  '2009',
  '2010',
  '2011',
  '2012',
  '2013',
  '2014',
  '2015',
  '2016',
  '2017',
  '2018',
  '2019',
  '2020',
  '2021',
];

export const locations = [
  { displayName: 'All Ireland', value: 'All Ireland' },
  { displayName: 'Dublin', value: 'Dublin' },
  { displayName: 'Leinster', value: 'Leinster' },
  { displayName: 'Munster', value: 'Munster' },
  { displayName: 'Ulster', value: 'Ulster' },
  { displayName: 'Connacht', value: 'Connacht' },
  { displayName: 'Antrim', value: 'Antrim' },
  { displayName: 'Armagh', value: 'Armagh' },
  { displayName: 'Carlow', value: 'Carlow' },
  { displayName: 'Cavan', value: 'Cavan' },
  { displayName: 'Clare', value: 'Clare' },
  { displayName: 'Cork', value: 'Cork' },
  { displayName: 'Derry', value: 'Derry' },
  { displayName: 'Donegal', value: 'Donegal' },
  { displayName: 'Down', value: 'Down' },
  { displayName: 'Dublin', value: 'Dublin' },
  { displayName: 'Fermanagh', value: 'Fermanagh' },
  { displayName: 'Galway', value: 'Galway' },
  { displayName: 'Kerry', value: 'Kerry' },
  { displayName: 'Kildare', value: 'Kildare' },
  { displayName: 'Kilkenny', value: 'Kilkenny' },
  { displayName: 'Laois', value: 'Laois' },
  { displayName: 'Leitrim', value: 'Leitrim' },
  { displayName: 'Limerick', value: 'Limerick' },
  { displayName: 'Longford', value: 'Longford' },
  { displayName: 'Louth', value: 'Louth' },
  { displayName: 'Mayo', value: 'Mayo' },
  { displayName: 'Meath', value: 'Meath' },
  { displayName: 'Monaghan', value: 'Monaghan' },
  { displayName: 'Offaly', value: 'Offaly' },
  { displayName: 'Roscommon', value: 'Roscommon' },
  { displayName: 'Sligo', value: 'Sligo' },
  { displayName: 'Tipperary', value: 'Tipperary' },
  { displayName: 'Tyrone', value: 'Tyrone' },
  { displayName: 'Waterford', value: 'Waterford' },
  { displayName: 'Westmeath', value: 'Westmeath' },
  { displayName: 'Wexford', value: 'Wexford' },
  { displayName: 'Wicklow', value: 'Wicklow' },
];

export type CountiesList = { displayName: string; value: string };

export const counties: CountiesList[] = [
  { displayName: 'Co. Dublin', value: 'Dublin' },
  { displayName: 'Co. Antrim', value: 'Antrim' },
  { displayName: 'Co. Armagh', value: 'Armagh' },
  { displayName: 'Co. Carlow', value: 'Carlow' },
  { displayName: 'Co. Cavan', value: 'Cavan' },
  { displayName: 'Co. Clare', value: 'Clare' },
  { displayName: 'Co. Cork', value: 'Cork' },
  { displayName: 'Co. Derry', value: 'Derry' },
  { displayName: 'Co. Donegal', value: 'Donegal' },
  { displayName: 'Co. Down', value: 'Down' },
  { displayName: 'Co. Dublin', value: 'Dublin' },
  { displayName: 'Co. Fermanagh', value: 'Fermanagh' },
  { displayName: 'Co. Galway', value: 'Galway' },
  { displayName: 'Co. Kerry', value: 'Kerry' },
  { displayName: 'Co. Kildare', value: 'Kildare' },
  { displayName: 'Co. Kilkenny', value: 'Kilkenny' },
  { displayName: 'Co. Laois', value: 'Laois' },
  { displayName: 'Co. Leitrim', value: 'Leitrim' },
  { displayName: 'Co. Limerick', value: 'Limerick' },
  { displayName: 'Co. Longford', value: 'Longford' },
  { displayName: 'Co. Louth', value: 'Louth' },
  { displayName: 'Co. Mayo', value: 'Mayo' },
  { displayName: 'Co. Meath', value: 'Meath' },
  { displayName: 'Co. Monaghan', value: 'Monaghan' },
  { displayName: 'Co. Offaly', value: 'Offaly' },
  { displayName: 'Co. Roscommon', value: 'Roscommon' },
  { displayName: 'Co. Sligo', value: 'Sligo' },
  { displayName: 'Co. Tipperary', value: 'Tipperary' },
  { displayName: 'Co. Tyrone', value: 'Tyrone' },
  { displayName: 'Co. Waterford', value: 'Waterford' },
  { displayName: 'Co. Westmeath', value: 'Westmeath' },
  { displayName: 'Co. Wexford', value: 'Wexford' },
  { displayName: 'Co. Wicklow', value: 'Wicklow' },
];

export const provinces = ['Leinster', 'Munster', 'Ulster', 'Connact'];

export const adSenseAdDetailsStyleId = '2340466210';
export const adSenseSearchStyleId = '8345744711';
export const dashboardPageSize = 10;

export enum ToastError {
  REGULAR = 'Oops! Something went wrong, please try again later',
}

export enum ToastSuccess {
  REGULAR = 'Updated successfully',
}

/**
 * Set this for local dev if you want to load the dealerhub pages still left in donedeal.
 *
 * @deprecated this will be removed when the last DH pages are migrated into the DH app.
 */
export const DEALERHUB_COOKIE =
  '__gsas=ID=2097610a911ba4c8:T=1653576827:S=ALNI_Mbic003OJWxz79GmkkktRzTcCv9-Q; _hjSessionUser_1063366=eyJpZCI6IjNjNzhhYTZjLTIxMWUtNWZkZS05ZTIyLWMwMjhmM2Q5YmFlOCIsImNyZWF0ZWQiOjE2NTM1NzY4MjcyNDMsImV4aXN0aW5nIjp0cnVlfQ==; ddSearchViewPreferenceV2=list; _fbp=fb.1.1653666363682.53180622; __zlcmid=1AFkxwk4R96k8UE; __stripe_mid=099a8168-9bf0-4fb6-8c8d-3db1f4f84642c27714; _hjMinimizedPolls=795652; _hjDonePolls=795652,796402,836410; _hjSessionUser_1063366=eyJpZCI6IjNjNzhhYTZjLTIxMWUtNWZkZS05ZTIyLWMwMjhmM2Q5YmFlOCIsImNyZWF0ZWQiOjE2NTM1NzY4MjcyNDMsImV4aXN0aW5nIjp0cnVlfQ==; donedealCC="{"version":1,"createDate":1653576825859,"lastUpdated":1669629267893,"expires":1685264067893,"strictlyNecessary":true,"analytics":true,"functional":true,"advertising":true}"; intercom-device-id-lbgq4460=d193fb64-2580-4c90-954d-bc025fa7fd06; intercom-id-lbgq4460=394253c6-12f5-4851-8542-a2e64dbe75b4; session=eyJyZXR1cm5UbyI6Imh0dHBzOi8vd3d3LmRvbmVkZWFsdGVzdC5jb20vIn0=; session.sig=r1xUstcXAqNhtPIaRwHlnBNFAJY; _hjSessionUser_3365962=eyJpZCI6IjFlOTg5MjBiLWY2MjMtNWNhYi05NjdmLTEyNTljYjAxNDMyOCIsImNyZWF0ZWQiOjE2NzY1NDM0NTQyMjAsImV4aXN0aW5nIjp0cnVlfQ==; _gcl_au=1.1.2141431920.1677592443; _gid=GA1.2.11962238.1677592443; ddSiteFocus=farming; NPS_4fb20f86_last_seen=1677689729555; __gpi=UID=00000b1161bb234a:T=1665742523:RT=1677836483:S=ALNI_Ma3-itxoj3_EucWQ4Z1M7GZBfHqBA; ddSiteFocus=farming; __gads=ID=405b67cc6610b925-2238e19d62d700a7:T=1653576825:S=ALNI_MaoHRehzqx3j0FJ8fp4_q08B5yHhA; cto_bundle=FUI48l90MnhwJTJGJTJGamthaGFTd0pIbDZGcks4cUNjaEIxdGZETCUyRlUyQXpuYUpYcyUyRnUyeXE1WjFpazcwb2clMkJVUmM1cFJ4aVd4NGplRlQzS0NSJTJGQnZrSE93bGEwbHJSQkd0aDRuMVYlMkI2bjdDJTJGS2duYjdzTENMQ0taZ3BlcE1mRjJqalpKRWNCczMxeCUyQk9abHhJR0hOSEY3UTgzamNka3lLUjRtVGxhVDhETGhOTDcwWmNNU3RWN1NDUEpueG51ajlxNjNpTmx0JTJGZzhjWkx0QXlVQm1TSERGUmFKZFElM0QlM0Q; ab.storage.deviceId.5100f42b-bed1-4f93-a38f-65494e81373e={"g":"41c65037-6e14-533b-528e-04faf6f11794","c":1644399181335,"l":1677842417075}; ab.storage.userId.5100f42b-bed1-4f93-a38f-65494e81373e={"g":"30670","c":1676644840548,"l":1677842417076}; _gat_UA-227208-1=1; _hjIncludedInSessionSample_1063366=0; _hjSession_1063366=eyJpZCI6IjhhNTA3ZmE5LWRiY2QtNDNhOS1iZjBmLTdiMTA5MjFhODQ5OCIsImNyZWF0ZWQiOjE2Nzc4NDI0MTc1ODMsImluU2FtcGxlIjpmYWxzZX0=; _hjAbsoluteSessionInProgress=0; ddRecommendedUser=74e96d20-8c29-4441-8d56-44b6ca4b8792; ab.storage.sessionId.5100f42b-bed1-4f93-a38f-65494e81373e={"g":"faaa2c88-04ac-374d-33b1-af9b54098ac6","e":1677844223219,"c":1677842417074,"l":1677842423219}; _ga_Y8KLBDT4CD=GS1.1.1677842416.52.1.1677842423.53.0.0; _ga=GA1.2.1201139891.1651238703; _hjIncludedInSessionSample_3365962=0; _hjSession_3365962=eyJpZCI6ImRmM2YwYjY0LWI2YTUtNDM4Mi05NDJiLTUxYTViZTY0YTA4YiIsImNyZWF0ZWQiOjE2Nzc4NDI0MjYxNDcsImluU2FtcGxlIjpmYWxzZX0=; _hjIncludedInPageviewSample=1; _gat_UA-164545759-8=1; DDSEISIUN=4F08ACC91280F7F3C488A307EB5DA99B; DDSIX=N33KB0Ys9Qhtsd_T8bSbrMOnEKIkZ6ZNC4GbzhXafud3kP077A3i5OEXyuE39EOwI73FFvMhQ0UPdIZ15ty2aXoo8_g6kwe_Wb5JfYnBbKQ; DDUS={"id":30049,"name":"aImmuniWeb","verification":{"email":true,"phone":true,"allowedAccess":true,"bank":true},"type":"DEALER","registrationdate":"2020-05-21+16:36:31.668"}; intercom-session-lbgq4460=S051Y2lUU1g1bGt6Sm1ObElaOU9PRlJnQmZLcWJBYkN3azFJS2tTT2NvWTVvSkJKU2ZJZGptL2JVMjBNb1gvSy0teEtqcTBET3R1NURXcnVvUmhzdUV1UT09--71135ca6cbabdce9e1d09b08805db72b551957db';

const ON_REQUEST_PRICE_SECTIONS = ['tractors', 'plantmachinery', 'beefcattle'];

export const isRequestPriceSection = (subsection: string) =>
  ON_REQUEST_PRICE_SECTIONS.includes(subsection);

export const PRICE_ON_REQUEST_TEXT = 'POA';
export const NO_PRICE_TEXT = 'No Price';

export const mileageOptions = [
  { label: 'km', value: MILEAGE_UNIT.KILOMETRES },
  { label: 'miles', value: MILEAGE_UNIT.MILES },
];

export const isMigratedPublishFilterSection = (subsection: string) =>
  MIGRATED_PUBLISH_FILTER_SECTIONS.includes(subsection);

/** Cookie constants */
export const COOKIE = {
  // An identifier for any user (logged in/out)
  DD_CLIENT_ID: 'ddClientId',
  // An identifier for a logged in user
  DD_CLIENT_UID: 'ddClientUid',
} as const;

/** Cookies can have a maximum max-age of 400 days in chrome */
export const MAXIMUM_COOKIE_AGE = 60 * 60 * 24 * 365;

/** Can be set as the 'Expires ' value to expire a cookie */
export const EXPIRE_COOKIE = 'Thu, 01 Jan 1970 00:00:00 GMT';

export const NEXT_AUTH_REFRESH_ACCESS_TOKEN_ERROR_MESSAGE =
  'RefreshAccessTokenError';
